// ────────────────────────────────────────────────────────────────────────────
// Last-known live-scan frame-consumption stats.
//
// LiveScanModal writes the App-Group poller's stats here when a scan
// session finalizes; BroadcastDiagnosticsPanel reads them on the Settings
// screen so a tester can see whether the host app actually consumed any
// app-group frames during the most recent run.
//
// Without this surface, the Live Scan Diagnostics card only showed disk
// state (framesOnDisk, status.frameCount) — there was no visible
// indication of whether the host app had reached into the App Group and
// pulled frames out, so a session that wrote N frames to disk but never
// dispatched them looked identical to a working session that consumed
// them all.
//
// Pure module-level state: no React, no persistence. Cleared when the
// modal mounts a new session via `clearLastLiveScanFrameStats()`.
// ────────────────────────────────────────────────────────────────────────────

import type { AppGroupFramePollerStats } from "./appGroupFramePoller";

export type LiveScanFrameStats = AppGroupFramePollerStats & {
  /** Wall-clock ms (Date.now()) when the modal recorded these stats. */
  recordedAt: number;
  /** Unix ms session start used as the stale-frame boundary. */
  sessionStartMs: number;
};

let last: LiveScanFrameStats | null = null;


export function getLastLiveScanFrameStats(): LiveScanFrameStats | null {
  return last;
}

export function clearLastLiveScanFrameStats(): void {
  last = null;
}
